import React, { Children } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Theme } from '../../../theme/types';

type SocialLink = {
    referTo: string;
    onLinkClick?: () => void;
    disabled?: boolean;
};

type StyleProps = {
    disabled: boolean;
};

const UserSocialLink: React.FC<SocialLink> = ({
    referTo,
    children,
    onLinkClick = () => {},
    disabled = false,
}) => {
    const classes = useStyles({ disabled });

    const getClickableLink = link => {
        if (disabled) {
            return '#';
        }

        return link.startsWith('http://') || link.startsWith('https://') ? link : `//${link}`;
    };

    const handleLinkClick = (event: React.MouseEvent | React.TouchEvent) => {
        if (disabled) {
            event.preventDefault();
            return;
        }

        onLinkClick();
    };

    return (
        <a
            href={getClickableLink(referTo)}
            className={classes.socialLink}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleLinkClick}
        >
            {Children.map(children, child => {
                if (React.isValidElement(child)) {
                    return React.cloneElement(child, {
                        className: classes.svgIcon,
                    });
                }
            })}
        </a>
    );
};

const useStyles = makeStyles<Theme, StyleProps>(
    theme => ({
        svgIcon: {
            height: 12,
            backgroundSize: '100%',
        },
        socialLink: {
            display: 'inline-flex',
            color: ({ disabled }) =>
                disabled ? theme.palette.greys[400] : theme.palette.greys[700],
            pointerEvents: ({ disabled }) => (disabled ? 'none' : 'auto'),

            '&:not(:first-child)': {
                marginLeft: 4,
            },
        },
    }),
    { classNamePrefix: 'social-link' }
);

export default UserSocialLink;
